<svg #customIcon [attr.viewBox]="svgData.viewBox" [attr.width]="size" [attr.height]="size"></svg>
